import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { hrmsGetRequest, hrmsPostRequest, hrmsUpdateRequest, hrmsDeleteRequest } from "../services/index";

const API_URL = "/api/hr/leave-limits";

// Fetch Leave Limits
export const fetchLeaveLimits = createAsyncThunk("leaveLimits/fetch", async () => {
  const response = await hrmsGetRequest(API_URL);
  return response.data;
});

// Add Leave Limit
export const addLeaveLimit = createAsyncThunk("leaveLimits/add", async (leaveLimitData) => {
  const response = await hrmsPostRequest(API_URL, leaveLimitData);
  return response.data;
});

// Update Leave Limit
export const updateLeaveLimit = createAsyncThunk("leaveLimits/update", async ({ id, leaveLimitData }) => {
  const response = await hrmsUpdateRequest(`${API_URL}/${id}`, leaveLimitData);
  return response.data;
});

// Delete Leave Limit
export const deleteLeaveLimit = createAsyncThunk("leaveLimits/delete", async (id) => {
  await hrmsDeleteRequest(`${API_URL}/${id}`);
  return id;
});

// Toggle Leave Limit Status
export const toggleLeaveLimitStatus = createAsyncThunk("leaveLimits/toggle", async (id) => {
  const response = await hrmsUpdateRequest(`${API_URL}/${id}/toggle`, {});
  return response.data;
});

// Toggle Leave Limit Auto-Assign
export const toggleLeaveLimitAutoAssign = createAsyncThunk("leaveLimits/toggleAutoAssign", async (id) => {
  const response = await hrmsUpdateRequest(`${API_URL}/${id}/toggle-auto-assign`, {});
  return response.data;
});

const leaveLimitSlice = createSlice({
  name: "leaveLimits",
  initialState: {
    leaveLimits: [],
    status: "idle",
    error: null,
  },
  reducers: {
    clearLeaveLimits: (state) => {
      state.leaveLimits = [];
      state.status = "idle";
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch Leave Limits
      .addCase(fetchLeaveLimits.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchLeaveLimits.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.leaveLimits = action.payload;
        state.error = null;
      })
      .addCase(fetchLeaveLimits.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      
      // Add Leave Limit
      .addCase(addLeaveLimit.pending, (state) => {
        state.status = "loading";
      })
      .addCase(addLeaveLimit.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.leaveLimits.push(action.payload);
        state.error = null;
      })
      .addCase(addLeaveLimit.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      
      // Update Leave Limit
      .addCase(updateLeaveLimit.pending, (state) => {
        state.status = "loading";
      })
      .addCase(updateLeaveLimit.fulfilled, (state, action) => {
        state.status = "succeeded";
        const index = state.leaveLimits.findIndex(limit => limit.id === action.payload.id);
        if (index !== -1) {
          state.leaveLimits[index] = action.payload;
        }
        state.error = null;
      })
      .addCase(updateLeaveLimit.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      
      // Delete Leave Limit
      .addCase(deleteLeaveLimit.pending, (state) => {
        state.status = "loading";
      })
      .addCase(deleteLeaveLimit.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.leaveLimits = state.leaveLimits.filter(limit => limit.id !== action.payload);
        state.error = null;
      })
      .addCase(deleteLeaveLimit.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      
      // Toggle Leave Limit Status
      .addCase(toggleLeaveLimitStatus.fulfilled, (state, action) => {
        const index = state.leaveLimits.findIndex(limit => limit.id === action.payload.id);
        if (index !== -1) {
          state.leaveLimits[index] = action.payload;
        }
      })
      
      // Toggle Leave Limit Auto-Assign
      .addCase(toggleLeaveLimitAutoAssign.fulfilled, (state, action) => {
        const index = state.leaveLimits.findIndex(limit => limit.id === action.payload.id);
        if (index !== -1) {
          state.leaveLimits[index] = action.payload;
        }
      });
  },
});

export const { clearLeaveLimits } = leaveLimitSlice.actions;
export default leaveLimitSlice.reducer; 